// The stamp in the inbox panel's `key`. Remounting the panel re-initialises its
// props-seeded state, which is wanted when the BE rewrote the row behind the
// operator's back (a refetch, a research run landing) and not wanted for a write the
// panel itself just made: it is its own scroll container and mounts a Leaflet map, so
// a remount throws the operator back to the top with every cell collapsed - once per
// org pick and once per autosave, if those counted.
//
// So the stamp only advances for an `updatedAt` this page did not produce. `selfSaved`
// is the SET of stamps this page's writes returned, not just the newest: two writes
// can overlap and their refetches can land out of order, so "is this one of ours?"
// cannot be answered by the last one alone. Switching lead resets everything.
export interface PanelKey {
  leadId: string;
  stamp: string;
}

export const nextPanelKey = (
  prev: PanelKey | null,
  lead: { id: string; updatedAt: string },
  selfSaved: ReadonlySet<string>
): PanelKey => {
  if (prev === null || prev.leadId !== lead.id) {
    return { leadId: lead.id, stamp: lead.updatedAt };
  }
  if (prev.stamp !== lead.updatedAt && !selfSaved.has(lead.updatedAt)) {
    return { leadId: lead.id, stamp: lead.updatedAt };
  }
  return prev;
};
